var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",staticStyle:{"display":"block"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer")],2)],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }